module.exports = __webpack_public_path__ + "static/media/pda.b394b839.svg";